// client/src/routes/app/properties/$propertyId/units.tsx — SCR-PROP-003 tab „Unități" ·
// PROP-004 (04 §8.3; 03 §7.3; the client half of 05 PROP-003).

import { createFileRoute } from '@tanstack/react-router';

import { UnitsTab } from '@/features/properties/UnitsTab';

export const Route = createFileRoute('/app/properties/$propertyId/units')({
  component: UnitsScreen,
});

function UnitsScreen() {
  const { propertyId } = Route.useParams();
  return <UnitsTab propertyId={propertyId} />;
}
